import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ContactService, ExtendedContact } from '../services/contact.service';
import {
  Contact,
  ContactFilterInput,
} from '../../generated/eveportal-api/graphql';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { SipService } from '../services/sip.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit, OnDestroy {
  contacts: ExtendedContact[] = [];
  searchTerm = '';
  pageSize = 4;
  loading = false;
  totalCount = 0;

  private searchTerm$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    private contactService: ContactService,
    private sipService: SipService
  ) {}

  ngOnInit(): void {
    this.searchTerm$
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe((term) => {
        this.loadContacts(false, term);
      });

    // Trigger initial load
    this.searchTerm$.next('');
  }


  onSearch(): void {
    this.contacts = [];
    this.totalCount = 0;
    this.searchTerm$.next(this.searchTerm);
  }

  onScrolledIndexChange(index: number): void {
    if (
      this.contacts.length < this.totalCount &&
      index + 5 >= this.contacts.length
    ) {
      this.loadContacts(true, this.searchTerm);
    }
  }

  loadContacts(append: boolean = false, term: string = ''): void {
    if (this.loading) return;
    this.loading = true;

    const skip = append ? this.contacts.length : 0;
    const take = this.pageSize;

    const filter: ContactFilterInput = term
      ? {
          or: [
            { firstName: { contains: term } },
            { surname: { contains: term } },
            { email: { contains: term } },
            { phoneNumber: { contains: term } },
          ],
        }
      : {};

    this.contactService
      .getContacts(filter, skip, take)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          const newContacts: ExtendedContact[] = res.items.map((contact) => ({
            ...contact,
            avatarUrl: 'assets/eveuser-avatar.png', // fallback default
          }));

          this.totalCount = res.totalCount;
          this.contacts = append
            ? [...this.contacts, ...newContacts]
            : newContacts;

          console.log('Contacts loaded:', this.contacts);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  onAddContact() {
    console.log('Add contact clicked');
  }

  toggleFavourite(contact: Contact) {
    contact.favourite = !contact.favourite;
  }

  async onCall(contact: Contact) {
    console.log('Calling', contact);
    await this.sipService.makeCall(
      contact.phoneNumber ?? contact.eveUserName ?? ''
    );
  }

  onChat(contact: Contact) {
    console.log('Chatting with', contact);
  }

  onVideoCall(contact: Contact) {
    console.log('Video calling', contact);
  }

  onDelete(contact: Contact) {
    console.log('Deleting', contact);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
